import { Typography } from "@mui/material";

interface ActiveFilterLabelProps {
    labels: string[],
    hiddenLabels?: string[]
}

const ActiveFilterLabel = ({labels, hiddenLabels = []}: ActiveFilterLabelProps) => {

    const isHidden = (label: string) => {
        const filterName = label.split(":")[0].trim();
        return hiddenLabels.includes(filterName)
    };

  return (
    <>
      {labels.filter((label) => !isHidden(label)).map((label, i) => (
            <Typography key={i} variant="caption" display="block">
                {label}
            </Typography>
        ))
    }
    </>
  );
};

export default ActiveFilterLabel;
